module.exports = __webpack_public_path__ + "img/pump-1.6802d044.png";